module.exports = __webpack_public_path__ + "static/media/red_tree.6f0e1262.png";